<template> 

<router-view/>

</template>

<script setup>

</script>

<style> 

html, body {
  overflow-y: scroll; /* Força a barra de rolagem vertical */
}

</style>
